import { APIService } from "@/services/APIService/APIService";
import { useService } from "@/services/ServiceContext";
import useSWRImmutable from "swr/immutable";

export function useServiceRequestTypes() {
	const api = useService(APIService.serviceKey);
	return useSWRImmutable("service-request-types", () =>
		api.serviceRequestTypes.getServiceRequestTypes()
	);
}
